// extracted by mini-css-extract-plugin
export default {"Language":"___Language__6uTfa","Header_nav":"___Header_nav__eM+bc"};